import { getTeamsPresence } from "@/repository/queryFns/teams";
import { PresenceState } from "@/common/constants/presence";
import { StorageKeys } from "@/common/constants/storageKeys";
import { Lockr } from "@/common/Lockr";
import { captureError } from "@/common/helpers/sentryHelper";

export const checkIsTeamsPresenceDnd = async (availability: string): Promise<boolean> => {
	if (availability === PresenceState.DND) {
		return true;
	}

	const userId = Lockr.get(StorageKeys.UserId) as string | undefined;
	if (!userId) {
		return false;
	}

	try {
		const teamsPresence = await getTeamsPresence(userId);

		return teamsPresence.availability === PresenceState.DND;
	} catch (err) {		
		captureError(err as Error, "checkIsTeamsPresenceDnd failed");

		return false;
	}
};
